<div fxLayout>
  <div fxFlex fxLayout fxLayout.lt-md="column" [ngStyle.lt-md]="{ marginTop: '24px' }">
    <div class="app-detail-sidebar" fxFlex="300px" fxFlex.lt-md="auto 0 0">
      <section fxLayout="column" fxLayoutGap="30px">
        <sbnb-back-button label="Back to apps"></sbnb-back-button>

        <img *ngIf="logoTile" [src]="logoTile" alt="{{ name }}" class="logo-tile" />
        <sbnb-button *ngIf="checking$ | async" [disabled]="true" [fullWidth]="true">Checking...</sbnb-button>

        <ng-container *ngIf="vendorCode && (checking$ | async) === false">
          <sbnb-button
            *ngIf="(isConnected$ | async) === false"
            [fullWidth]="true"
            [loading]="generatingConnectionUrl$ | async"
            (click)="generateConnectionUrl()">
            Get started
          </sbnb-button>

          <ng-container *ngIf="(isConnected$ | async) === true">
            <div fxLayoutAlign="center center" fxLayoutGap="8px">
              <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
              <span class="grass-darker text__large">Connected!</span>
            </div>

            <button mat-flat-button class="button__primary button__small" (click)="deleteAppPrompt()">
              Remove access
            </button>
          </ng-container>
        </ng-container>

        <section *ngIf="builtBy" id="built-by" fxLayout="column" fxLayoutGap="8px">
          <strong>Built by</strong>
          <span *ngIf="!builtByLink">{{ builtBy }}</span>
          <a *ngIf="builtByLink" [attr.href]="builtByLink" target="_blank" class="raspberry-darker text__small">
            {{ builtBy }}
          </a>
        </section>

        <section
          *ngIf="categories && categories.length > 0"
          id="categories"
          fxLayout="column"
          fxLayoutGap="8px"
          fxLayoutAlign="start start">
          <strong>Categories</strong>
          <div class="flex flex-wrap" style="gap: 6px">
            <span *ngFor="let category of categories" class="app__item-category">{{ category }}</span>
          </div>
        </section>

        <section *ngIf="permissions?.length > 0" id="permissions" fxLayout="column">
          <strong>Permissions</strong>
          <ul>
            <li *ngFor="let permission of permissions" class="text-sm">{{ permission }}</li>
          </ul>
        </section>

        <section
          *ngIf="phone || email || helpLink || helpArticles?.length > 0"
          id="support"
          fxLayout="column"
          fxLayoutGap="12px">
          <strong>Support</strong>

          <ng-container *ngIf="helpArticles?.length > 0">
            <div
              *ngFor="let article of helpArticles"
              class="help-article"
              fxLayoutAlign="start center"
              fxLayoutGap="6px">
              <div fxLayoutAlign="start start" fxLayoutGap="6px">
                <sbnb-icon icon="book-open" [size]="14" class="text-grass-darker mt-1"></sbnb-icon>
                <a fxFlex class="leading-5" (click)="intercomService.openHelpArticle(article.id)">
                  {{ article.title }}
                </a>
              </div>
            </div>
          </ng-container>

          <div *ngIf="phone" class="phone" fxLayoutAlign="start center" fxLayoutGap="6px">
            <sbnb-icon icon="phone" [size]="14" class="text-grass-darker"></sbnb-icon>
            <a [attr.href]="'tel:' + phone">{{ phone }}</a>
          </div>

          <div *ngIf="email" class="email" fxLayoutAlign="start center" fxLayoutGap="6px">
            <sbnb-icon icon="email" [size]="14" class="text-grass-darker"></sbnb-icon>
            <a href="mailto:{{ email }}" target="_blank">{{ email }}</a>
          </div>

          <div *ngIf="helpLink" class="helpLink" fxLayoutAlign="start center" fxLayoutGap="6px">
            <sbnb-icon
              [icon]="helpLink.icon ? helpLink.icon : 'book-open'"
              [size]="14"
              class="text-grass-darker"></sbnb-icon>
            <a fxFlex [href]="helpLink.href" target="_blank">{{ helpLink.text }}</a>
          </div>
        </section>
      </section>
    </div>

    <main fxFlex fxLayout="column" fxLayoutGap="40px" class="subnav__exists" [ngClass.lt-md]="{ mobile: true }">
      <section fxLayoutAlign="start center" fxLayoutGap="12px">
        <h2 class="nomargin">{{ name }}</h2>
        <span *ngIf="beta" class="badge">Beta</span>
      </section>

      <section *ngIf="description" fxLayout="column" fxLayoutGap="20px">
        <h3 class="nomargin">About the integration</h3>
        <ng-content select="[description]"></ng-content>
      </section>

      <ng-content></ng-content>
    </main>
  </div>
</div>
